const getCallbackUrl = (theapp) => {
	let start_conditions = theapp.getStartConditions();

	if (start_conditions.callbackurl) {
		// only if specified to the widget
		return start_conditions.callbackurl;
	}
}

export default getCallbackUrl;